import React from 'react'
import { connect } from 'react-redux'
import { doCreateSalaryApply } from '../../reducers/actions'

class AddMonthlySalaryApplyDiv extends React.Component {
	state = {
		changedValues基本信息: {},
		initValues基本信息: {}
	}
	handlerConfirm = () => {
		const { changedValues基本信息 } = this.state
		const { onSave, onClose, dispatch } = this.props
		dispatch(doCreateSalaryApply({
			changedValues基本信息,
			onEnd: ({ errorMessage }) => {
				if (errorMessage) {
					Tyan.pubForm.showError(errorMessage)
				}
				else {
					Ext.toast('保存成功')
					onSave && onSave()
					onClose && onClose()
				}
			}
		}))
	}

	handlerClose = () => {
		const { onClose } = this.props
		onClose && onClose()
	}

	canSave = () => {
		const { initValues基本信息, changedValues基本信息 } = this.state
		return Object.keys(changedValues基本信息).length > 0
	}

	fieldset基本信息 = () => {
		var year = new Date().getFullYear()
		var month = new Date().getMonth() + 2
		var option = [year + '年' + month + '月']
		for (var i = 0; i < 2; i++) {
			if (month == 1) {
				month = 12
				year = year - 1
			}
			else {
				month = month - 1
			}
			option.push(year + '年' + month + '月')
		}
		return [
			{ _select: '发放月份', name: '薪资期号', options: option },
		]
	}

	render() {
		const { showMessage: Message, showBody: Body, id } = this.props
		const canSave = this.canSave()
		return <Body data={this} maxWidth="600"
			controls={
				[
					{ _button: '确定', icon: 'save', handler: this.handlerConfirm, disabled: !canSave },
					{ _button: '取消', icon: 'close', handler: this.handlerClose },
				]}
			fieldsets={
				[
					{ title: '', name: '基本信息', _fieldset: this.fieldset基本信息() },
				]}
		/>
	}
}

export default connect()(AddMonthlySalaryApplyDiv)